import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { ReactNode } from "react";
import AdditionalInfo from "@/components/common/additionalInfo/additionalInfo";
import { ArrowRightIcon } from "@/components/common/icons";
import { GREY, WHITE } from "@/config/mui/colorPalette";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import { MIXED_APPOINTMENT_TYPES_ERROR_MESSAGE } from "./bookingNavBar";

export const BookingStepperToolbar = ({
  visible,
  hasMixedAppointmentTypes,
  onContinue,
  continueDisabled,
  buttonBackgroundColor,
  buttonTextColor,
}: {
  visible: boolean;
  hasMixedAppointmentTypes: boolean;
  onContinue: () => void;
  continueDisabled: boolean;
  buttonBackgroundColor: string;
  buttonTextColor: string;
}) => {
  const isMobile = useMoxieMediaQuery("ipad-hor", "down");
  return (
    <>
      {hasMixedAppointmentTypes && (
        <AdditionalInfo
          variant="error"
          text={MIXED_APPOINTMENT_TYPES_ERROR_MESSAGE}
          sx={{ m: 0, mt: { xs: 1, md: 0 } }}
        />
      )}
      <ResponsiveAppBar visible={visible} isMobile={isMobile}>
        <Toolbar
          disableGutters={!isMobile}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "100%", md: "auto" },
          }}
        >
          <Box />
          <Button
            onClick={onContinue}
            variant="contained"
            size={isMobile ? "large" : "small"}
            sx={{
              backgroundColor: buttonBackgroundColor
                ? buttonBackgroundColor
                : "primary",
              my: 2,
            }}
            disabled={continueDisabled}
            endIcon={
              <ArrowRightIcon color={continueDisabled ? GREY[40] : WHITE} />
            }
          >
            <Typography
              variant="buttonSmall"
              sx={{
                color: continueDisabled ? "text.disabled" : buttonTextColor,
              }}
            >
              Next step
            </Typography>
          </Button>
        </Toolbar>
      </ResponsiveAppBar>
    </>
  );
};

const ResponsiveAppBar = ({
  children,
  visible,
  isMobile = false,
}: {
  children: ReactNode;
  visible: boolean;
  isMobile?: boolean;
}) => {
  if (!visible) return null;
  if (!isMobile) return <>{children}</>;

  return (
    <AppBar
      sx={{
        py: 0.5,
        top: "auto",
        bottom: 0,
        bgcolor: "white",
        borderTop: `1px solid ${GREY[20]}`,
        px: { md: "96px" },
        visibility: visible ? "visible" : "hidden",
      }}
    >
      {children}
    </AppBar>
  );
};
